export default __webpack_public_path__ + "static/media/home-icon.d74d0a2b.svg";